// extracted by mini-css-extract-plugin
module.exports = {"accordition_container":"GlobalAccordition_accordition_container__12GGP","dropdown_icon":"GlobalAccordition_dropdown_icon__2QCHL","ac_content":"GlobalAccordition_ac_content__1OP8V"};